import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import { mascCoin, mascPercent } from "../../../../Helpers/Masc";

// Import the components
import TableHeader from "./Components/TableHeader/TableHeader";
import ContextMenu from "./Components/ContextMenu/contextMenu";

// Import the CSS file
import "./FixedTable.css";

// Import the formater data
import { format } from "date-fns";

// Import the translation hook
import { useTranslation } from "react-i18next";

import { Check2Circle, XCircle } from "react-bootstrap-icons";
import TableFooter from "./Components/TableFooter/TableFooter";
export default function FixedTable({
    table,
    columns,
    data,
    menu,
    reload,
    disableDirection = false,
    height = "260px",
    pagination = true,
    empty = "No data available",
}) {
    // Get the translation function
    const { t } = useTranslation();

    // Check if the screen is small (mobile)
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const [contextMenu, setContextMenu] = useState({
        visible: false,
        x: 0,
        y: 0,
        openUpward: false,
    });
    const [idMenu, setIdMenu] = useState(0);

    // Function to format the date
    const formatDate = (date, type) => {
        if (
            date === null ||
            date === undefined ||
            date === "0001-01-01T00:00:00Z"
        ) {
            return "";
        }

        if (type === "date-time") {
            return format(new Date(date), t("date.format.date-time"));
        }

        return format(new Date(date), t("date.format.date"));
    };

    function getNestedValue(obj, path, value) {
        const returnValue = path
            .split(".")
            .reduce((acc, key) => acc && acc[key], obj);
        if (value) {
            return returnValue ? value[returnValue] : "";
        }

        return returnValue;
    }

    const handleContextMenu = (event, data) => {
        event.preventDefault();

        const screenHeight = window.innerHeight;
        const cursorY = event.clientY;
        const estimatedMenuHeight = menu.length * 40;
        const shouldOpenUpward =
            cursorY + estimatedMenuHeight > screenHeight - 20;

        setIdMenu(data);
        setContextMenu({
            visible: true,
            x: event.clientX,
            y: cursorY,
            openUpward: shouldOpenUpward,
        });
    };

    const handleClick = () => {
        setContextMenu({ visible: false, x: 0, y: 0 });
    };

    const [theme, setTheme] = useState("light");
    useEffect(() => {
        setTheme(document.documentElement.getAttribute("data-bs-theme"));
        document.addEventListener("click", handleClick);
        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, []);

    const getContent = (row, column) => {
        // Armazena o conteúdo de cada célula da linha
        return columns.map((column, colIndex) => {
            let content = null;

            // Verifica se o tipo é uma função para obter o tipo dinâmico
            if (typeof column.type === "function") {
                const typeResult = column.type(row);
                column = { ...column, type: typeResult };
            }

            switch (column.type) {
                case "date":
                    content =
                        getNestedValue(row, column.field) &&
                        formatDate(
                            getNestedValue(row, column.field),
                            column.type
                        );
                    break;
                case "date-time":
                    content =
                        getNestedValue(row, column.field) &&
                        formatDate(
                            getNestedValue(row, column.field),
                            column.type
                        );
                    break;
                case "boolean":
                    content = getNestedValue(row, column.field) ? (
                        <Check2Circle
                            style={{
                                color: "#45dc35",
                            }}
                        />
                    ) : (
                        <XCircle
                            style={{
                                color: "red",
                            }}
                        />
                    );
                    break;
                case "!boolean":
                    content =
                        getNestedValue(row, column.field) &&
                        (!getNestedValue(row, column.field)
                            ? t("boolean.true")
                            : t("boolean.false"));
                    break;
                case "currency":
                    content = mascCoin(
                        getNestedValue(row, column.field) || 0,
                        t("currency.symbol"),
                        t("currency.precision"),
                        t("currency.decimal"),
                        t("currency.thousands")
                    );
                    break;
                case "percent":
                    content = mascPercent(
                        getNestedValue(row, column.field) || 0,
                        t("currency.decimal"),
                        2
                    );
                    break;
                case "actions":
                    content = (
                        <div className="table-column-action">
                            {column.actions &&
                                column.actions.map((action, index) => {
                                    return action.desabled ? (
                                        action.desabled(row) ? null : (
                                            <span
                                                key={row["id"] + index}
                                                onClick={() =>
                                                    action.handle(row)
                                                }
                                            >
                                                {action.icon}
                                            </span>
                                        )
                                    ) : (
                                        <span
                                            key={row["id"] + index}
                                            onClick={() => action.handle(row)}
                                        >
                                            {action.icon}
                                        </span>
                                    );
                                })}
                        </div>
                    );
                    break;
                default:
                    if (column.masc) {
                        content = column.masc(
                            getNestedValue(row, column.field)
                        );
                    } else {
                        content = getNestedValue(
                            row,
                            column.field,
                            column.value
                        );
                    }
                    break;
            }

            if (typeof column.style === "function") {
                const style = column.style(row);
                column = { ...column, style: style };
            }

            return (
                <td
                    key={
                        row["id"] +
                        "-" +
                        (column.key || column.field) +
                        "-" +
                        colIndex
                    }
                    className={
                        column.type !== "string"
                            ? "table-column table-column-center"
                            : "table-column"
                    }
                    style={column.style ? column.style : {}}
                >
                    {content}
                </td>
            );
        });
    };

    return (
        <div className="table-container" style={{ "--table-height": height }}>
            <div className="table-scrollable">
                <Table hover>
                    <TableHeader
                        table={table}
                        columns={columns}
                        reload={reload}
                        disableDirection={disableDirection}
                    />
                    <tbody>
                        {Array.isArray(data) && data.length > 0 ? (
                            data.map((row, index) => (
                                <tr
                                    key={index}
                                    onContextMenu={
                                        menu
                                            ? (e) => {
                                                  handleContextMenu(e, row);
                                              }
                                            : null
                                    }
                                >
                                    {getContent(row, columns)}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={columns.length}
                                    style={{ textAlign: "center" }}
                                >
                                    {empty}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
            {/* Em mobile, renderiza o footer fora mas com posicionamento especial */}
            {isMobile && pagination && (
                <div className="table-footer-mobile-container">
                    <TableFooter table={table} reload={reload} />
                </div>
            )}

            {/* Em desktop, renderiza o footer fora do container scrollável */}
            {!isMobile && pagination && (
                <TableFooter table={table} reload={reload} />
            )}
            <ContextMenu
                menu={menu}
                data={idMenu}
                position={contextMenu}
                visible={contextMenu.visible}
                openUpward={contextMenu.openUpward}
                onClose={() => {
                    setContextMenu({
                        visible: false,
                        x: 0,
                        y: 0,
                        openUpward: false,
                    });
                }}
                theme={theme}
            />
        </div>
    );
}
